import { UserException } from '@/domain/user/exception/UserException'

export class UnauthorizedException extends UserException {
}
